import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ImageDataDb } from '../../_shared/data/image-data-db.data';
import { IHeroSmall } from '../../_shared/models/hero/hero-small.model';
import { MediaImage } from '../../_shared/models/media/media-image.model';
import { CastPipe } from '../../_shared/pipes/cast.pipe';
import { LinkDirective } from '../../_shared/directives/link.directive';
import { ButtonComponent } from '../../button/button.component';
import { HeadingComponent } from '../../heading/heading.component';
import { ImageItemComponent } from '../../media/media-item/image-item/image-item.component';
import { HeroBase } from '../hero-base.directive';
import { ContainerComponent } from '../../container/container.component';

@Component({
    selector: 'sirius-hero-small',
    templateUrl: './hero-small.component.html',
    styleUrls: ['./hero-small.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        // [class.sir-hero-has-mobile-image]: '!!(backgroundImageMobile ?? backgroundImage)',
        '[class.sir-hero-variant-dark]': 'variant === "dark"',
        '[class.sir-hero-has-image]': '!!(backgroundImageDesktop ?? backgroundImage)',
    },
    imports: [
    CastPipe,
    ImageItemComponent,
    HeadingComponent,
    ButtonComponent,
    LinkDirective,
    ContainerComponent
]
})
export class HeroSmallComponent extends HeroBase implements OnInit {
    /** @deprecated Use backgroundImageMobile and backgroundImageDesktop. See IHeroSmall.backgroundImage */
    @Input() backgroundImage?: MediaImage;
    // @Input() backgroundImageMobile?: MediaImage;
    @Input() backgroundImageDesktop?: MediaImage;
    @Input() config?: IHeroSmall;

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.buttonPrimary = this.config.buttonPrimary;
            this.buttonSecondary = this.config.buttonSecondary;
            this.backgroundImage = this.config.backgroundImage;
            // this.backgroundImageMobile = this.config.backgroundImageMobile;
            this.backgroundImageDesktop = this.config.backgroundImageDesktop;
            if (this.config.variant) {
                this.variant = this.config.variant;
            }
        }

        this._breadcrumbService.setVariant(this.variant);
        this.imageData = ImageDataDb.hero.image;
    }
}
